import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reset window scroll to the top on every route change so that clicking
 * a link — especially from the mobile hamburger menu — visibly opens the
 * new page at its top instead of preserving the previous route's scroll
 * position. Mounted once inside <BrowserRouter> in App.js.
 *
 * Anchor navigation (e.g. `/#authors`) is intentionally preserved: when
 * `location.hash` is set we scroll to the matching element instead of
 * jumping to (0,0), so in-page anchor links keep working.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ block: "start" });
        return;
      }
    }
    // `behavior: "auto"` = instant. A route change should feel like a
    // page load, not an animated scroll.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}

export default ScrollToTop;
